import React from "react";
import { Reveal } from "@/lib/motion";

const paragraphs = [
  "Hi, I'm Nathan. I'm 22 and I've been training consistently for four years. For most of that time I was just as confused as everyone else.",
  "One video says one thing, then the very next contradicts it. Nobody seemed to agree, and hardly anybody had solid research to back up their ideas.",
  "So I went to the source. I've spent the past two years reading studies and trying to truly understand health and fitness on a deeper level. What I found changed everything. Not because the truth was complicated, but because almost nobody was telling it. Most of what gets taught in Personal Training certification courses has been contradicted by research that's been available for years. The fitness industry just hasn't caught up.",
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 md:py-40 max-w-[1400px] mx-auto px-6 md:px-12"
    >
      <Reveal>
        <h2 className="font-syne font-bold tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[0.98] text-white">About</h2>
      </Reveal>

      <div className="mt-10 md:mt-14 max-w-3xl space-y-7">
        {paragraphs.map((p, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <p className="text-lg md:text-xl leading-relaxed font-light text-white/55">
              {p}
            </p>
          </Reveal>
        ))}
        <Reveal delay={paragraphs.length * 0.08}>
          <p className="text-xl md:text-2xl leading-relaxed font-light text-white/90 font-syne tracking-tight">
            HANCOCK exists because you deserve coaching built on evidence, not
            trends. Friendly, honest, and always in your corner.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
